// extracted by mini-css-extract-plugin
export var addToCartButton = "_ny-b";
export var arrowButtonContainer = "_ny-9";
export var arrowButtonIcon = "_ny-a";
export var carouselArrowButton = "_ny-6";
export var carouselElementContainer = "_ny-1";
export var galleryThumbnail = "_ny-d";
export var galleryThumbnailImage = "_ny-e";
export var left = "_ny-7";
export var productDisplayCarouselContainer = "_ny-0";
export var productTileContainer = "_ny-2";
export var productTileImage = "_ny-4";
export var productTileImageContainer = "_ny-3";
export var productTileTitle = "_ny-5";
export var right = "_ny-8";
export var sliderOverflow = "_ny-c";